import { createReduxHistory } from 'modules/router/state';
import { store } from 'store';

export const reduxHistory = createReduxHistory(store);
